<template>
  <div class="data_item">
    <div class="item_top">
      <p>{{ itemTitle }}</p>
    </div>
    <!--    每日申请单量趋势-->
    <div class="item_content item-right" v-loading="true" ref="itemLeftTop" v-if="itemType === 'leftTop'">
      <MyEcharts v-if="getApplyOrderInfo" chartId="amount _trend" :options="getApplyOrderInfo" width="100%" height="100%"></MyEcharts>
      <div class="loading-dom" v-else><div class="loader"></div></div>
    </div>
    <!--    每日任务数量趋势-->
    <div class="item_content item-right" v-else-if="itemType === 'leftCenter'">
      <MyEcharts chartId="task _trend" v-if="getTaskTrend" :options="getTaskTrend" width="100%" height="100%"></MyEcharts>
      <div class="loading-dom" v-else><div class="loader"></div></div>
    </div>
    <!--    资产申请列表-->
    <div class="item_content item-right" v-else-if="itemType === 'leftBottom'">
      <div class="asset_application">
        <span class="assets_no">申请单号</span>
        <span class="applay_unit">申请人员</span>
        <span class="applay_tel">联系方式</span>
        <span class="applay_status">审批状态</span>
      </div>
      <vue-seamless-scroll v-if="getApplyList" ref="seamlessScroll" :data="getApplyList" :class-option="classOption" class="warp right-bottom-color">
        <ul class="item">
          <li v-for="(item, index) in getApplyList" :key="index">
            <div class="assets_no hover-box">
              <span class="item_span" v-text="item.apply_no"></span>
              <span class="tooltip" v-text="item.apply_no"></span>
            </div>
            <div class="applay_unit hover-box">
              <span class="item_span" v-text="item.user.nickname"></span>
              <span class="tooltip" v-text="item.user.nickname"></span>
            </div>
            <div class="applay_tel hover-box">
              <span class="item_span" v-text="item.user.mobile"></span>
              <span class="tooltip" v-text="item.user.mobile"></span>
            </div>
            <div class="applay_status hover-box">
              <span class="item_span" v-text="item.status_text"></span>
              <span class="tooltip" v-text="item.status_text"></span>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>
      <div class="loading-dom" v-else><div class="loader"></div></div>
    </div>
    <!--    系统数据情况-->
    <div class="item_content" v-else-if="itemType === 'rightTop'">
      <div class="item_left_top" v-if="getIndicators">
        <div class="data_container_item" @click="redirectToPage('http://zichan.172tc.com/aKgGteWDLI.php/depository?ref=addtabs')">
          <p class="item_name">仓库总数</p>
          <CountTo class="item_num" :duration="3000" :startVal="0" :endVal="this.$store.state.bi.indicators.depo_cnt"></CountTo>
        </div>
        <div class="data_container_item" @click="redirectToPage('http://zichan.172tc.com/aKgGteWDLI.php/zc?ref=addtabs')">
          <p class="item_name">装备总数</p>
          <CountTo class="item_num" :duration="3000" :startVal="0" :endVal="this.$store.state.bi.indicators.zc_cnt"></CountTo>
        </div>
        <div class="data_container_item" @click="redirectToPage('http://zichan.172tc.com/aKgGteWDLI.php/zc_apply?ref=addtabs')">
          <p class="item_name">申请总数</p>
          <CountTo class="item_num" :duration="3000" :startVal="0" :endVal="this.$store.state.bi.indicators.apply_cnt"></CountTo>
          <!--          <p class="item_num">{{ getIndicators.apply_cnt }}</p>-->
        </div>
        <div class="data_container_item" @click="redirectToPage('http://zichan.172tc.com/aKgGteWDLI.php/tasks?ref=addtabs')">
          <p class="item_name">任务总数</p>
          <CountTo class="item_num" :duration="3000" :startVal="0" :endVal="this.$store.state.bi.indicators.task_cnt"></CountTo>
        </div>
      </div>
      <div class="loading-dom right-bottom-color" v-else><div class="loader"></div></div>
    </div>
    <!--    装备状态-->
    <div class="item_content item-left" v-else-if="itemType === 'rightCenter'">
      <!--        在库可用的、故障的、报废的、使用中的-->
      <MyEcharts chartId="equipment_status" v-if="getZCInfo" :options="getZCInfo" width="100%" height="100%"></MyEcharts>
      <div class="loading-dom" v-else><div class="loader"></div></div>
    </div>
    <!--    任务派发列表-->
    <div class="item_content item-left" v-else-if="itemType === 'rightBottom'">
      <div class="asset_application right-bottom-color">
        <span class="assets_no">任务编号</span>
        <span class="applay_unit">执行人员</span>
        <span class="applay_tel">联系方式</span>
        <span class="applay_status">审批状态</span>
      </div>
      <vue-seamless-scroll v-if="getTaskList" ref="seamlessScroll" :data="getTaskList" :class-option="classOption" class="warp left-bottom-color">
        <ul class="item">
          <li ref="scrollItem" v-for="(item, index) in getTaskList" :key="index">
            <div class="assets_no hover-box">
              <span class="item_span" v-text="item.task_no"></span>
              <span class="tooltip" v-text="item.task_no"></span>
            </div>
            <div class="applay_unit hover-box">
              <span class="item_span" v-text="item.user.nickname"></span>
              <span class="tooltip" v-text="item.user.nickname"></span>
            </div>
            <div class="applay_tel hover-box">
              <span class="item_span" v-text="item.user.mobile"></span>
              <span class="tooltip" v-text="item.user.mobile"></span>
            </div>
            <div class="applay_status hover-box">
              <span class="item_span" v-text="item.status_text"></span>
              <span class="tooltip" v-text="item.status_text"></span>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>
      <div class="loading-dom" v-else><div class="loader"></div></div>
    </div>
  </div>
</template>

<script>
import MyEcharts from '@/components/MyEcharts.vue';
import vueSeamlessScroll from 'vue-seamless-scroll';
import CountTo from 'vue-count-to';
import { mapState } from 'vuex';

const leftBackColor = {
  type: 'linear',
  x: 0,
  y: 0,
  x2: 1,
  y2: 0,
  colorStops: [
    {
      offset: 0,
      color: 'rgba(2, 30, 68, 0.8)' // 0% 处的颜色
    },
    {
      offset: 1,
      color: 'rgba(2, 30, 68, 0.2)' // 100% 处的颜色
    }
  ],
  global: false // 缺省为 false
};
const rightBackColor = {
  type: 'linear',
  x: 0,
  y: 0,
  x2: 1,
  y2: 0,
  colorStops: [
    {
      offset: 0,
      color: 'rgba(2, 30, 68, 0.2)' // 0% 处的颜色
    },
    {
      offset: 1,
      color: 'rgba(2, 30, 68, 0.8)' // 100% 处的颜色
    }
  ],
  global: false // 缺省为 false
};
export default {
  name: 'DataItem',
  props: {
    itemTitle: {
      type: String,
      default: '标题'
    },
    itemType: {
      type: String,
      default: 'leftTop'
    }
  },
  components: { MyEcharts, vueSeamlessScroll, CountTo },
  data() {
    return {
      classOption: {
        step: 5,
        singleHeight: 30
      }
    };
  },
  watch: {
    options() {
      if (this.myChart) {
        this.myChart.setOption(this.options, {
          notMerge: true
        });
      }
    }
  },
  mounted() {},
  computed: {
    ...mapState('bi', ['indicators', 'applyList', 'taskList', 'zcInfo', 'questInfo', 'applyOrderInfo']),
    // 系统数据情况
    getIndicators() {
      return this.indicators ? this.indicators : false;
    },
    // 资产申请列表
    getApplyList() {
      return this.applyList ? this.applyList : false;
    },
    // 任务派发列表
    getTaskList() {
      return this.taskList ? this.taskList : false;
    },
    // 装备状态统计
    getZCInfo() {
      if (this.zcInfo) {
        const _zcInfo = this.zcInfo;
        const chartOptionArr = [];

        for (const key in _zcInfo) {
          let chartOptionObj = {};
          switch (key) {
            case 'normal':
              chartOptionObj.name = '可用';
              break;
            case 'fault':
              chartOptionObj.name = '故障';
              break;
            case 'scrapped':
              chartOptionObj.name = '报废';
              break;
            case 'out':
              chartOptionObj.name = '使用中';
              break;
            case 'fixing':
              chartOptionObj.name = '维修中';
              break;
            case 'pending':
              chartOptionObj.name = '建档阶段';
              break;
            default:
              chartOptionObj.name = key;
          }
          chartOptionObj.value = _zcInfo[key];
          chartOptionArr.push(chartOptionObj);
          chartOptionObj = {};
        }

        const equipmentStatus = {
          backgroundColor: leftBackColor,
          tooltip: {
            trigger: 'item',
            textStyle: {
              color: 'white' // 设置tooltip文字颜色为白色
            },
            formatter: function (params) {
              // 使用 CSS 格式的颜色代码设置文字颜色
              return `<div style="color:${params.color};">${params.marker}${params.data.name}: ${params.data.value}</div>`;
            }
          },
          legend: {
            top: '5%',
            left: 'center'
          },
          series: [
            {
              type: 'pie',
              radius: '50%',
              data: chartOptionArr,
              label: {
                show: true,
                color: 'white',
                formatter: '{b}:({d}%)',
                overflow: 'none'
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        };
        return equipmentStatus;
      } else {
        return false;
      }
    },
    // 每日申请单量
    getApplyOrderInfo() {
      if (this.applyOrderInfo) {
        const _applyOrderInfo = this.applyOrderInfo;
        const amountTrend = {
          backgroundColor: rightBackColor,
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '15%',
            right: '5%',
            bottom: '25%'
          },
          xAxis: {
            boundaryGap: true,
            data: _applyOrderInfo.map(function (item) {
              return item[0];
            })
          },
          yAxis: {
            name: '每日任务次数',
            nameLocation: 'end',
            nameTextStyle: {
              align: 'center'
            },
            type: 'value',
            axisLabel: {
              formatter: '{value} 次'
            }
          },
          dataZoom: [
            {
              startValue: '2014-06-01',
              type: 'slider',
              width: '70%',
              height: '20',
              top: '85%',
              right: '15%'
            }
          ],
          series: {
            type: 'bar',
            axisTick: {
              alignWithLabel: true
            },
            data: _applyOrderInfo.map(function (item) {
              return item[1];
            })
          }
        };
        return amountTrend;
      } else {
        return false;
      }
    },
    // 每日任务数量
    getTaskTrend() {
      if (this.questInfo) {
        const _questInfo = this.questInfo;
        const taskTrend = {
          backgroundColor: rightBackColor,
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '15%',
            right: '5%',
            bottom: '25%'
          },
          xAxis: {
            boundaryGap: true,
            data: _questInfo.map(function (item) {
              return item[0];
            })
          },
          yAxis: {
            name: '每日任务次数',
            nameLocation: 'end',
            nameTextStyle: {
              align: 'center'
            },
            type: 'value',
            axisLabel: {
              formatter: '{value} 次'
            }
          },
          dataZoom: [
            {
              startValue: '2014-06-01',
              type: 'slider',
              width: '70%',
              height: '20',
              top: '85%',
              right: '15%'
            }
          ],
          series: {
            type: 'line',
            axisTick: {
              alignWithLabel: true
            },
            data: _questInfo.map(function (item) {
              return item[1];
            })
          }
        };
        return taskTrend;
      } else {
        return false;
      }
    }
  },
  methods: {
    redirectToPage(href) {
      window.location.href = href;
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.data_item {
  width: 100%;
  position: relative;
  height: 33.3%;
  //background: linear-gradient(to right, rgba(1, 195, 147, 0.8) 0%, rgba(1, 195, 147, 0.2) 100%);

  .item_top {
    width: 100%;
    height: 15%;
    font-family: 'NotoSansCJK-Regular';
    font-size: 16px;
    text-align: left;
    color: white;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: linear-gradient(to right, rgba(1, 195, 147, 0.8) 0%, rgba(1, 195, 147, 0.2) 100%);

    p {
      font-size: 20px;
      padding-left: 10px;
      vertical-align: center;
    }

    &::before {
      content: '';
      width: 0px;
      height: 0px;
      border-color: #25a1de transparent transparent transparent;
      border-style: solid;
      border-width: 10px 10px 0 0;
      position: absolute;
      top: 0px;
      left: 0px;
    }
  }

  .item_content {
    height: 85%;
    //background: linear-gradient(to right, rgba(34, 98, 169, 0.6) 0%, rgba(34, 98, 169, 0.8) 100%);
    //background: linear-gradient(to right, rgba(2, 30, 68, 0.8) 0%, rgba(2, 30, 68, 0.2) 100%);
    .asset_application {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      height: 15%;

      .applay_status {
        width: 20%;
      }
      .applay_tel {
        width: 20%;
      }
      .applay_unit {
        width: 30%;
      }
      .assets_no {
        width: 30%;
      }

      span {
        height: auto;
        font-family: 'NotoSansCJK-Regular';
        font-size: 16px;
      }
    }
    .warp {
      height: 78.5%;
      width: 100%;
      margin: 0 auto;
      overflow: hidden;
      padding: 0 10px;

      li:nth-child(2n) {
        background: linear-gradient(97deg, rgba(1, 195, 147, 0.6166667350533963) 0%, rgba(1, 195, 147, 0.8) 100%);
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0 auto;
        li,
        a {
          display: block;
          height: 30px;
          line-height: 30px;
          display: flex;
          justify-content: space-between;
          font-size: 15px;
        }

        li {
          height: 30px;
          border-radius: 2px;

          .applay_status {
            width: 20%;
          }
          .applay_tel {
            width: 20%;
          }
          .applay_unit {
            width: 30%;
          }
          .assets_no {
            width: 30%;
          }

          .hover-box {
            display: flex;
            flex-direction: row;
            align-items: center;
            position: relative;

            .item_span {
              display: block;
              width: 100%;
              line-height: 20px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding: 0 5px;
            }

            .tooltip {
              width: auto;
              height: auto;
              background-color: white;
              color: #333;
              visibility: hidden;
              text-align: center;
              padding: 5px;
              border-radius: 5px;
              line-height: 30px;
              /* 位置调整 */
              position: absolute;
              top: 0%;
              left: 5%;
              z-index: 10;
              //margin-left: -75px;
            }

            &:hover .tooltip {
              visibility: visible;
            }
          }
        }
      }
    }
    .loading-dom {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .loader {
      width: 50px;
      aspect-ratio: 1;
      display: grid;
      border: 4px solid #0000;
      border-radius: 50%;
      border-color: #ccc #0000;
      animation: l16 1s infinite linear;
    }
    .loader::before,
    .loader::after {
      content: '';
      grid-area: 1/1;
      margin: 2px;
      border: inherit;
      border-radius: 50%;
    }
    .loader::before {
      border-color: #f03355 #0000;
      animation: inherit;
      animation-duration: 0.5s;
      animation-direction: reverse;
    }
    .loader::after {
      margin: 8px;
    }
    @keyframes l16 {
      100% {
        transform: rotate(1turn);
      }
    }
  }

  .item-left {
    .asset_application {
      background: linear-gradient(to right, rgba(2, 30, 68, 0.8) 0%, rgba(2, 30, 68, 0.2) 100%);
    }
    .loading-dom {
      background: linear-gradient(to right, rgba(2, 30, 68, 0.8) 0%, rgba(2, 30, 68, 0.2) 100%);
    }
  }
  .item-right {
    .asset_application {
      background: linear-gradient(to right, rgba(2, 30, 68, 0.2) 0%, rgba(2, 30, 68, 0.8) 100%);
    }
    .loading-dom {
      background: linear-gradient(to right, rgba(2, 30, 68, 0.2) 0%, rgba(2, 30, 68, 0.8) 100%);
    }
  }

  .item_left_top {
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    justify-items: center;
    align-items: center;
    background: linear-gradient(to right, rgba(2, 30, 68, 0.8) 0%, rgba(2, 30, 68, 0.2) 100%);

    .data_container_item {
      width: 40%;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 2%;
      cursor: pointer;

      .item_name {
        font-family: YouSheBiaoTiHei;
        font-size: 30px;
      }

      .item_num {
        font-family: YouSheBiaoTiHei;
        font-size: 50px;
      }
    }
  }

  .right-bottom-color {
    background: linear-gradient(to right, rgba(2, 30, 68, 0.2) 0%, rgba(2, 30, 68, 0.8) 100%);
  }
  .left-bottom-color {
    background: linear-gradient(to right, rgba(2, 30, 68, 0.8) 0%, rgba(2, 30, 68, 0.2) 100%);
  }
}
</style>
